import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

import { helpDispatch, Tooltip } from 'components/admin/Help';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
  },
  button: {
    position: 'relative',
    margin: theme.spacing.unit,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
  },
  divider: {
    flexGrow: 1,
    maxWidth: '2px',
    margin: '10px 10px',
    background: grey[300],
  },
});

const ActionsContent = ({ classes, actions, help, authUser }) => {
  return(
    <div className={classes.root}>
      {actions &&
        actions.map((action, i) => {
          const actionParams = action.type === "print" ? action.params : {};

          if (action.type === "divider") {
            return <div key={i} className={classes.divider} />;
          } else if(action.tooltipType) {
            return(
              <Tooltip type={action.tooltipType} placement={action.tooltipPlacement}>
                <Button
                  id={action.tooltipType}
                  className={classNames(classes.button, help.isCurrentStep(action.tooltipType) && classes.elevate)}
                  variant="raised"
                  color={action.color}
                  key={i}
                  onClick={() => {
                    const useDefaultEmail = help.isCurrentStep(action.tooltipType);
                    helpDispatch();
                    if (useDefaultEmail){
                      actionParams.defaultEmail = authUser.email;
                      //return action.handleAction(authUser.email);
                    } else {
                      //return action.handleAction();
                    }
                    return action.handleAction(actionParams);
                  }}
                >
                  {action.value}
                </Button>
              </Tooltip>
            );
          } else {
            return(
              <Button
                id={action.tooltipType}
                className={classes.button}
                variant="raised"
                color={action.color}
                key={i}
                onClick={() => {
                  helpDispatch();
                  return action.handleAction(actionParams);
                }}
              >
                {action.value}
              </Button>
            );
          }
        })
      }
    </div>
  );
};

const mapStateToProps = state => ({
  authUser: state.sessionState.authUser,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ActionsContent);



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/ActionsContent.jsx